'use client';

import { useIsUserLoggedIn, WatchlistProvider } from '@benzinga/user-context';

import { BzEverywhere } from './BzEverywhere';
import { PortfolioWorkspace } from './PortfolioWorkspace';
import { WatchlistModals } from './modals';
import { getPortfolioPageShell, usePortfolioShellTakeover } from './portfolioPageShell';

export const ProfilePortfolioPageClient = () => {
  const sessionLoggedIn = useIsUserLoggedIn();
  const { cookieLoggedIn, mounted } = usePortfolioShellTakeover();

  if (!mounted) {
    return null;
  }

  const shell = getPortfolioPageShell(sessionLoggedIn, cookieLoggedIn);

  if (shell === 'marketing') {
    return (
      <div className="bg-[#f1f8fe]">
        <BzEverywhere priority />
      </div>
    );
  }

  return (
    <WatchlistProvider>
      <PortfolioWorkspace />
      <WatchlistModals />
    </WatchlistProvider>
  );
};
